import { AMPHeaderAndSideBar, Header, HeaderWithSubMenus } from 'mm-ui-components';
import { useSelector } from 'react-redux';
import React from 'react';
import { getPrimaryHeader } from '../../store/navigation/doubleHeader/primaryHeader/primaryHeader.selectors';
import { getSecondaryHeader } from '../../store/navigation/doubleHeader/secondaryHeader/secondaryHeader.selectors';
import { getHeaderWithSubMenus } from '../../store/navigation/default-old/headerWithSubMenus/headerWithSubMenus.selectors';
import { getHeader } from '../../store/navigation/default/header/header.selectors';
import { getMenu } from '../../store/navigation/default/menu/menu.selectors';
import { getEditionEndpoint, getPagePath } from '../../store/config/config.selectors';

export const DoubleHeaderConnected: React.FunctionComponent = () => {
  const primaryHeader = useSelector(getPrimaryHeader);
  const secondaryHeader = useSelector(getSecondaryHeader);
  const pagePath = useSelector(getPagePath);
  const editionEndpoint = useSelector(getEditionEndpoint);
  return <Header {...{ primaryHeader, secondaryHeader }} pagePath={pagePath} editionEndpoint={editionEndpoint} />;
};

export const AMPHeaderConnected: React.FunctionComponent = () => {
  const primaryHeader = useSelector(getPrimaryHeader);
  const secondaryHeader = useSelector(getSecondaryHeader);
  const pagePath = useSelector(getPagePath);
  const editionEndpoint = useSelector(getEditionEndpoint);
  return <AMPHeaderAndSideBar {...{ primaryHeader, secondaryHeader }} pagePath={pagePath} editionEndpoint={editionEndpoint} />;
};

export const OldDefaultHeaderConnected: React.FunctionComponent = () => {
  const headerWithSubMenus = useSelector(getHeaderWithSubMenus);
  return <HeaderWithSubMenus {...headerWithSubMenus} />;
};

export const DefaultHeaderConnected: React.FunctionComponent = () => {
  const header = useSelector(getHeader);
  const menu = useSelector(getMenu);
  const pagePath = useSelector(getPagePath);
  const editionEndpoint = useSelector(getEditionEndpoint);
  return <HeaderWithSubMenus {...header} menu={menu} pagePath={pagePath} editionEndpoint={editionEndpoint} />;
};
